import { getUtmSourceCookie } from '#pplx/frontend/apps/ask/browser-state/cookieManager.js';
const PARTNERSHIP_UTM_SOURCE = 'partnerships';
/**
 * Checks if the user is coming from a partnership campaign
 * First check cookie (persisted according to query param)
 * If no cookie, check query param directly (cookie may not be set in time)
 */
export const isPartnershipCampaign = () => {
    const utmSourceCookie = getUtmSourceCookie();
    if (utmSourceCookie === PARTNERSHIP_UTM_SOURCE) {
        return true;
    }
    if (typeof window === 'undefined') {
        return false;
    }
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const utmSourceParam = searchParams.get('utm_source');
    return utmSourceParam === PARTNERSHIP_UTM_SOURCE;
};
//# sourceMappingURL=partnershipUtils.js.map